import React,{useState,useEffect} from 'react'
import {Table} from 'react-bootstrap'
import AdminDashboard from "../../components/AdminDashboard"
import Exchange from "../../components/assets/gg_arrows-exchange-alt.png";
import { useSnackbar } from "notistack";
import axios from "axios"
import useFetch from "../../hooks/useFetch"
const url = "https://www.bitmasta.io/php/admin_pass.php"
export default function AdminSetRate(props) {
  const { enqueueSnackbar } = useSnackbar();
    const [buyRate,setBuyRate]=useState({BTC:"",ETH:"",USDT:"",LTC:""})
    const [sellRate,setSellRate]=useState({BTC:"",ETH:"",USDT:"",LTC:""})
  const {response:rates} = useFetch()
   
    useEffect(()=>{
        if(rates.length > 0){
            setBuyRate({BTC:rates.filter((el)=>el.Crypto === "BTC")[0].Buy,ETH:rates.filter((el)=>el.Crypto === "ETH")[0].Buy,USDT:rates.filter((el)=>el.Crypto === "USDT")[0].Buy,LTC:rates.filter((el)=>el.Crypto === "LTC")[0].Buy})

            setSellRate({BTC:rates.filter((el)=>el.Crypto === "BTC")[0].Sell,ETH:rates.filter((el)=>el.Crypto === "ETH")[0].Sell,USDT:rates.filter((el)=>el.Crypto === "USDT")[0].Sell,LTC:rates.filter((el)=>el.Crypto === "LTC")[0].Sell})
            
        }
    },[rates])
    const onUpdateEth = ()=>{
        const formData = new FormData()
        formData.append("New_Rate",true)
        formData.append("Crypto","ETH")
        formData.append("Sell",sellRate.ETH)
        formData.append("Buy",buyRate.ETH)
        formData.append("Address",null)
        try{
            axios.post(url,formData).then(res=>{
                if(res.data.status === "Rate Inserted"){
                    enqueueSnackbar(res.data.message, {
                        variant: "success",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "right",
                        },
                      });

                }
                else{
                    enqueueSnackbar(res.data.message, {
                        variant: "error",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "right",
                        },
                      });
                }
            })
        }
        catch(err){
            console.log(err);
        }
    }
    const onUpdateBtc = ()=>{
        const formData = new FormData()
        formData.append("Crypto","BTC")
        formData.append("Sell",sellRate.BTC)
        formData.append("Address",null)
        formData.append("Buy",buyRate.BTC)
        formData.append("New_Rate",true)

        try{
            axios.post(url,formData).then(res=>{
                if(res.data.status === "Updated"){
                    enqueueSnackbar(res.data.message, {
                        variant: "success",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "right",
                        },
                      });
                      
                }
                else{
                    enqueueSnackbar(res.data.message, {
                        variant: "error",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "right",
                        },
                      });
                }
            })
        }
        catch(err){
            console.log(err);
        }
    }
    const onUpdateLTC = ()=>{
        const formData = new FormData()
        formData.append("Crypto","LTC")
        formData.append("Sell",sellRate.LTC)
        formData.append("Address",null)
        formData.append("Buy",buyRate.LTC)
        formData.append("New_Rate",true)

        try{
            axios.post(url,formData).then(res=>{
                if(res.data.status === "Rate Inserted"){
                    enqueueSnackbar(res.data.message, {
                        variant: "success",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "right",
                        },
                      });
                      
                }
                else{
                    enqueueSnackbar(res.data.message, {
                        variant: "error",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "right",
                        },
                      });
                }
            })
        }
        catch(err){
            console.log(err);
        }
    }
    const onUpdateUsdt = ()=>{
        const formData = new FormData()
        formData.append("Crypto","USDT")
        formData.append("Sell",sellRate.USDT)
        formData.append("Address",null)
        formData.append("Buy",buyRate.USDT)
        formData.append("New_Rate",true)

        try{
            axios.post(url,formData).then(res=>{
                if(res.data.status === "Rate Inserted"){
                    enqueueSnackbar(res.data.message, {
                        variant: "success",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "right",
                        },
                      });
                      
                }
                else{
                    enqueueSnackbar(res.data.message, {
                        variant: "error",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "right",
                        },
                      });
                }
            })
        }
        catch(err){
            console.log(err);
        }
    }
    return (
        
        <AdminDashboard {...props}>
            <Table responsive>
                <thead>
                        <tr>
                            <th>Type</th>
                            <th>Wallet Address</th>
                            <th></th>
                            <th>Buy</th>
                            <th></th>
                            <th>Sell</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="lightBlueBg">BTC</td>
                            <td className="lightBlueBg">1Pj954PZatmiULxvdbMewewaAzoCPfr6hJ</td>
                            <td className="darkBlueBg dollar-sign">$</td>
                            <td className="darkBlueBg">
                                <input type="number" onChange={e=>setBuyRate({...buyRate,BTC:e.target.value})} value={buyRate.BTC} className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <img src={Exchange} alt=""/>
                            </td>
                            <td className="darkBlueBg">
                                <input type="number" onChange={e=>setSellRate({...sellRate,BTC:e.target.value})} value={sellRate.BTC} className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <button onClick={onUpdateBtc} className="update-button">Update</button>
                            </td>
                        </tr>
                        <tr>
                            <td className="lightBlueBg">ETH</td>
                            <td className="lightBlueBg">0x1b156d28C4168556909Ca4eCbf5c40A7d2Af7df7</td>
                            <td className="darkBlueBg dollar-sign">$</td>
                            <td className="darkBlueBg">
                                <input type="number" onChange={e=>setBuyRate({...buyRate,ETH:e.target.value})} value={buyRate.ETH} className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <img src={Exchange} alt=""/>
                            </td>
                            <td className="darkBlueBg">
                                <input type="number" onChange={e=>setSellRate({...sellRate,ETH:e.target.value})} value={sellRate.ETH} className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <button onClick={onUpdateEth} className="update-button">Update</button>
                            </td>
                        </tr>
                        <tr>
                            <td className="lightBlueBg">LTC</td>
                            <td className="lightBlueBg">LShptoMcCgdwFM17UTXYJAyYrkFLunXW8v</td>
                            <td className="darkBlueBg dollar-sign">$</td>
                            <td className="darkBlueBg">
                                <input type="number" onChange={e=>setBuyRate({...buyRate,LTC:e.target.value})} value={buyRate.LTC} className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <img src={Exchange} alt=""/>
                            </td>
                            <td className="darkBlueBg">
                                <input type="number" onChange={e=>setSellRate({...sellRate,LTC:e.target.value})} value={sellRate.LTC} className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <button onClick={onUpdateLTC} className="update-button">Update</button>
                            </td>
                        </tr>
                        <tr>
                            <td className="lightBlueBg">USDT</td>
                            <td className="lightBlueBg">0x66b827643ffb070ed9dd05a4dd74db655312c412</td>
                            <td className="darkBlueBg dollar-sign">$</td>
                            <td className="darkBlueBg">
                                <input type="number" onChange={e=>setBuyRate({...buyRate,USDT:e.target.value})} value={buyRate.USDT} className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <img src={Exchange} alt=""/>
                            </td>
                            <td className="darkBlueBg">
                                <input type="number" onChange={e=>setSellRate({...sellRate,USDT:e.target.value})} value={sellRate.USDT}  className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <button onClick={onUpdateUsdt} className="update-button">Update</button>
                            </td>
                        </tr>
                        {/* <tr>
                            <td className="lightBlueBg">DSH</td>
                            <td className="lightBlueBg"></td>
                            <td className="darkBlueBg dollar-sign">$</td>
                            <td className="darkBlueBg">
                                <input type="number" value="400" className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <img src={Exchange} alt=""/>
                            </td>
                            <td className="darkBlueBg">
                                <input type="number" value="300" className="ratesInput"/>
                            </td>
                        </tr>
                        <tr>
                            <td className="lightBlueBg">Litecoin</td>
                            <td className="lightBlueBg"></td>
                            <td className="darkBlueBg dollar-sign">$</td>
                            <td className="darkBlueBg">
                                <input type="number" value="400" className="ratesInput"/>
                            </td>
                            <td className="darkBlueBg">
                                <img src={Exchange} alt=""/>
                            </td>
                            <td className="darkBlueBg">
                                <input type="number" value="400" className="ratesInput"/>
                            </td>
                        </tr>
                     */}
                    </tbody>
            </Table>
        </AdminDashboard>
    )
}
